<template>
  <div class="goods">
    <div class="imgBox" @click="goDetail(goodsData)">
      <img :src="goodsData.MainPic" alt="">
    </div>
    <div class="price">
      <span class="price1">￥{{goodsData.Price}}</span>
      <span class="price2">￥{{goodsData.LinePrice}}</span>
    </div>
    <div class="title">
      <span>{{goodsData.ProName}}</span>
    </div>
  </div>
</template>
<script>
import imgurl from '../assets/bktj.png'
export default {
  name: 'AXgoods',
  props: {
    goodsData: {
      type: Object,
      default: () => {
        return{
          imgUrl: imgurl,
          price1: '38335.00',
          LinePrice: '88888.00',
          label: '海尔冰箱冰箱尔冰箱冰箱海尔冰箱冰箱尔冰箱冰箱'
        }
      }
    }
  },
  methods:{
    goDetail(val){
      this.$router.push({path:'/home/goodsDetail',query: {spuId: val.Id}})
    }
  }
}
</script>
<style lang="scss" scoped>
.goods{
  display: inline-block;
  width: 256px;
  height: 357px;
  background: #fff;
  padding: 16px;
  .imgBox{
    width: 256px;
    height: 256px;
    margin-bottom: 16px;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
      transition: all .15s linear .15s;
    }
    img:hover{
      transform: translate(0, -10px);
      // transition: all .3s linear .3s;
    }
  }
  .price{
    margin-bottom: 8px;
    text-align: left;
  }
  .price1{
    font-size: 24px;
    font-weight: 800;
    color: #f40000;
    line-height: 33px;
  }
  .price2{
    font-size: 18px;
    font-weight: 500;
    color: #999;
    line-height: 25px;
    text-decoration: line-through;
    margin-left: 8px;
  }
  .title{
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    line-height: 22px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>